import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Select, MenuItem, InputBase, FormControl, InputLabel, Box, Typography } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Cookies from 'js-cookie';


const WhatsAppSenders = () => {
  
	const ServerApiDomain = process.env.REACT_APP_SPRING_SERVER_API_DOMAIN;
	const API_URL = `${ServerApiDomain}/embedded-signups/all`;
	const AUTH = 'Basic ' + btoa('testuser:testpassword');
	const CookieAccountName = Cookies.get('current_accountName');
	const CookieAccountId = Cookies.get('current_accountId');
	
	const [FullPageloading, setFullPageloading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  
  const HandleShowModal = () => {
	  
    setShow(true);
	setErrorName("");
	setName("");
    setNameError(false);
	setErrorEmail("");
	setEmail("");
    setEmailError(false);
    setInputApiArea("true");
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };  
  
  const [Name, setName] = useState('');
  const [NameError, setNameError] = useState(false);
  const [ErrorName, setErrorName] = useState('');
  
  
  const [SuccessModalHeading, setSuccessModalHeading] = useState('');
  const [SuccessModalSubHeading, setSuccessModalSubHeading] = useState('');
  
  const [EmailSentTo, setEmailSentTo] = useState('');
  const NameRef = useRef(null);
  
  const [Email, setEmail] = useState('');
  const [EmailError, setEmailError] = useState(false);
  const [ErrorEmail, setErrorEmail] = useState('');
  const EmailRef = useRef(null);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
  const handleAddSender = () =>{
	  
		setErrorName("");
		setNameError(false);
		setErrorEmail("");
		setEmailError(false);
	if (Name.trim() === '') {
		setErrorName("Please enter a sender name");
		setNameError(true);
		NameRef.current.focus();
		return;
	}else if (Email.trim() === '') {
		setErrorEmail("Please enter a sender email address");
		setEmailError(true);
		EmailRef.current.focus();
		return;
	}else if (!emailRegex.test(Email)) {
		setErrorEmail("Please enter a valid email address");
		setEmailError(true);
		EmailRef.current.focus();
		return;
	}
	handleAddDomain();
  };
  
  
  const [Domain, setDomain] = useState('');
  const [DomainError, setDomainError] = useState(false);
  const [ErrorDomain, setErrorDomain] = useState('');
  const [DomainAdded, setDomainAdded] = useState('');
  const [DomainSentTo, setDomainSentTo] = useState('');
  const DomainRef = useRef(null);
  const [verifyDomainLink, setVerifyDomainLink] = useState('');
  
  const [InputApiArea, setInputApiArea] = useState('true');
  
  
	const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [noData, setNoData] = useState(false);
    const loadedIds = useRef(new Set());

    const fetchData = useCallback(async () => {
		if (loading || !hasMore) return;
	
		setLoading(true);
		try {
			const response = await fetch(`${API_URL}?username=${CookieAccountId}&page=${page}&&pageSize=50`, {
				headers: { 'Authorization': AUTH }
			});
			const result = await response.json();
	
			if (result.content.length > 0) {
				const newData = result.content.filter(item => !loadedIds.current.has(item.wabaId));
	
				if (newData.length > 0) {
					setData(prevData => [...prevData, ...newData]);
					newData.forEach(item => loadedIds.current.add(item.wabaId));
					setPage(prevPage => prevPage + 1);
				}
			} 
			
			// Handle case when no more data is available
			if (result.lastPage || result.content.length === 0) {
				setHasMore(false);
			}
	
			// Handle case where no data was ever returned
			if (page === 0 && result.content.length === 0) {
				setNoData(true);
			}
		} catch (error) {
			console.error('Error fetching data:', error);
		} finally {
			setLoading(false);
		}
	}, [loading, hasMore, page]);
	
	useEffect(() => {
		fetchData();
	}, [fetchData]);
	

    const observer = useRef();

    const lastElementRef = useCallback(node => {
        if (loading) return;
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                fetchData();
            }
        });
        if (node) observer.current.observe(node);
    }, [loading, fetchData]);
	
	
	const current_username = CookieAccountId;
	const username = 'testuser';
	const password = 'testpassword';
	const encodedCredentials = btoa(`${username}:${password}`);
	
	const [open, setOpen] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
	
	const handleClickOpen = (id) => {
        setSelectedId(id);
        setOpen(true);
    };

    const handleCloseDeleteModal = () => {
        setOpen(false);
        setSelectedId(null);
    };
	
	
	const handleAddDomain = async () => {
		const requestData = {
			username: CookieAccountId, // The username input
			email: Email, // Use the email from state
			senderName: Name // Use the sender name from state
		};
		
		try {
			const response = await fetch(`${ServerApiDomain}/senders-email/add`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Basic ${encodedCredentials}`,
				},
				body: JSON.stringify(requestData),
			});

			if (response.ok) {
				const newEmail = await response.json(); // Assuming the API returns the new email object
				
				// Add the new email to the data state
				setData(prevData => {
					const updatedData = [
						...prevData,
						{
							id: newEmail.id, // Assuming the new email object has an id
							email: newEmail.email,
							senderName: newEmail.senderName,
							status: newEmail.status, // You may want to adjust this based on the API response
							datetime: new Date().toISOString() // Set current date/time or from response
						}
					];
					
					 if (newEmail.status === 'pending') {
						setSuccessModalHeading('Verification Sent!');
						setSuccessModalSubHeading(`Verification Link sent to ${newEmail.email}`);
					} else {
						setSuccessModalHeading('Email Added!!');
						setSuccessModalSubHeading(`Your sender ${newEmail.email} has been automatically verified because it matches an authenticated domain.`);
					}

					// If this was the first email, hide the no data message
					if (prevData.length === 0) {
						setNoData(false);
					}

					return updatedData;
				});

				setEmailSentTo(Email);
				setInputApiArea("false");
				showSnackbar('Sender added successfully!', 'success');
			} else {
				alert('Failed to add Email');
			}
		} catch (error) {
			console.error('Error:', error);
		}
	};

	
	
	
	const handleDelete = async () => {
		try {
			const response = await fetch(`${ServerApiDomain}/embedded-signups/${selectedId}/delete-embedded-signup?username=${current_username}`, {
				method: 'DELETE',
				headers: {
					'Authorization': `Basic ${encodedCredentials}`,
				},
			});
			if (response.ok) {
            setData(prevData => {
                const updatedData = prevData.filter(item => item.wabaId !== selectedId);
                setNoData(updatedData.length === 0); // Check if the data is empty
                return updatedData;
            });
            showSnackbar('WhatsApp Account Removed!', 'success');
        } else {
            alert('Failed to remove the whatsapp account');
        }
		} catch (error) {
			alert('Error:', error);
		} finally {
			handleCloseDeleteModal();
		}
	};

	const sendSignupData = async (phoneNumberId, wabaId, event) => {
		try {
		  await fetch(`${ServerApiDomain}/embedded-signups/create`, {
			method: "POST",
			headers: {
			  "Content-Type": "application/json",
			},
			body: JSON.stringify({
			  username: CookieAccountId,
			  phoneNumberId,
			  wabaId,
			  event,
			  version: 2,
			}),
		  });
		  showSnackbar('WhatsApp account linked successfully!', 'success');
		  setTimeout(() => {
			window.location.reload();
		  }, 3000);		
		} catch (error) {
		  alert("Error sending signup data:"+ error);
		}
	  };

	  
	useEffect(() => {
		// Load Facebook SDK
		window.fbAsyncInit = function () {
		  window.FB.init({
			appId: "1634373277186143",
			autoLogAppEvents: true,
			xfbml: true,
			version: "v22.0",
		  });
		};
	
		const script = document.createElement("script");
		script.src = "https://connect.facebook.net/en_US/sdk.js";
		script.async = true;
		script.defer = true;
		script.crossOrigin = "anonymous";
		document.body.appendChild(script);
	
		// Event listener for messages from Facebook
		const messageHandler = (event) => {
		  if (
			event.origin !== "https://www.facebook.com" &&
			event.origin !== "https://web.facebook.com"
		  ) {
			return;
		  }
		  try {
			const data = JSON.parse(event.data);
			if (data.type === "WA_EMBEDDED_SIGNUP") {
			  if (data.event === "FINISH") {
				sendSignupData(data.data.phone_number_id, data.data.waba_id, data.event);
				console.log("Phone number ID", data.data.phone_number_id);
				console.log("WhatsApp business account ID", data.data.waba_id);
			  } else if (data.event === "CANCEL") {
				console.warn("Cancel at", data.data.current_step);
				showSnackbar(`WhatsApp Signup was canceled at step: ${data.data.current_step}. Please try again.`, 'error');
			  } else if (data.event === "ERROR") {
				showSnackbar(`An error occurred: ${data.data.error_message}. Please check your details and try again.`, 'error');
				console.error("Error", data.data.error_message);
			  }
			}
			document.getElementById("session-info-response").textContent = JSON.stringify(
			  data,
			  null,
			  2
			);
		  } catch {
			console.log("Non-JSON Responses", event.data);
		  }
		};
	
		window.addEventListener("message", messageHandler);
		
		return () => {
		  window.removeEventListener("message", messageHandler);
		};
	  }, []);
	
	  const fbLoginCallback = (response) => {
		document.getElementById("sdk-response").textContent = JSON.stringify(response, null, 2);
	  };
	
	  const launchWhatsAppSignup = () => {
		window.FB.login(fbLoginCallback, {
		  config_id: "577406778617388",
		  response_type: "code",
		  override_default_response_type: true,
		  extras: {
			setup: {},
			featureType: "",
			sessionInfoVersion: "2",
		  },
		});
	  };
	    
	 	const [selectedAccount, setSelectedAccount] = useState(null); // store WABA/Phone info
		const [sidebarData, setSidebarData] = useState(null);         // data fetched from Meta
	  	
		const fetchWhatsAppInfo = async (phoneNumberId) => {
			try {
				const response = await fetch(`https://graph.facebook.com/v22.0/${phoneNumberId}?access_token=EAAXOdC6dZBF8BO3LCIaOvvPw2SjoeROmuRG8a7MohiZCnaEGkvk9tOXq2He3Gew8upLJL46Cc1uq4sDrmqXIZA09z4RU8k8M58xJ0xdCgT5UXbuCEb7B4ZCOJhZBTq7MZBHLW9R7meQMbPJBNcdfYnhKFmOUWf7XlV4ZCAeX8eDkfndv9JOayfgXO7yNAE6pliJfi58vKUbPe9IPoT2sJCAOlpWo8MZD`);
				const data = await response.json();
				setSidebarData(data);
			} catch (err) {
				console.error("Error fetching WhatsApp info:", err);
			}
		};


	  	const toggleSidebar = (phoneNumberId, wabaId) => {
			setSelectedAccount({ phoneNumberId, wabaId }); // optional if needed later
			fetchWhatsAppInfo(phoneNumberId);              // fetch Meta data
			document.querySelector(".sidebar").classList.add("active");
			document.querySelector(".overlay").classList.add("active");
		};


  return (					
			<div className="main-area">
		    <Backdrop
				sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={FullPageloading}
			>
				<CircularProgress color="inherit" />
			</Backdrop>
			<div className="secondary-heading-area border-bottom-0 p-0">
				
			</div>
			<div className="sidebar-wrapper">

      <div className="sidebar">
		<div className='toggle-sidebar-nav'>
			<div className='row'>
			<div className='col-10'>
				<h4 className='toggle-sidebar-title'>
				{sidebarData?.verified_name || 'Loading...'}
				</h4>
			</div>
			<div className='col-2'>
				<i className='bi bi-x' onClick={() => {
				document.querySelector(".sidebar").classList.remove("active");
				document.querySelector(".overlay").classList.remove("active");
				setSidebarData(null);
				}}></i>
			</div>
			</div>
		</div>

		<div className='toggle-sidebar-body'>
			<div className='row align-items-center'>
			<div className='col-6'><h6 className='toggle-sidebar-label'>Phone Number</h6></div>
			<div className='col-6'><h6 className='toggle-sidebar-text'>{sidebarData?.display_phone_number || '----------'}</h6></div>

			<div className='col-6'><h6 className='toggle-sidebar-label'>Verified Name</h6></div>
			<div className='col-6'><h6 className='toggle-sidebar-text'>{sidebarData?.verified_name || '----------'}</h6></div>

			<div className='col-6'><h6 className='toggle-sidebar-label'>Quality Rating</h6></div>
			<div className='col-6'><h6 className='toggle-sidebar-text'>{sidebarData?.quality_rating || '----------'}</h6></div>

			<div className='col-6'><h6 className='toggle-sidebar-label'>Platform</h6></div>
			<div className='col-6'><h6 className='toggle-sidebar-text'>{sidebarData?.platform_type || '----------'}</h6></div>

			<div className='col-6'><h6 className='toggle-sidebar-label'>Status</h6></div>
			<div className='col-6'><h6 className='toggle-sidebar-text'>{sidebarData?.code_verification_status || '----------'}</h6></div>
			

			{/* You can keep your existing static fields below if needed */}
			</div>
		</div>
	</div>


      {/* Overlay */}
      <div className="overlay" onClick={() => {
				document.querySelector(".sidebar").classList.remove("active");
				document.querySelector(".overlay").classList.remove("active");
				setSidebarData(null);
				}}></div>
    </div>

			<div className="form-area">
				<div className="row">
					<div className="col-4">
						  <h4 className="secondary-heading">WhatsApp Account Verification</h4>
						  <h6 className="secondary-subheading">Verify ownership of a WhatsApp account to use as a sender. <a href="" className="d-none">Learn more</a></h6>
						  {noData ? (
						  <button type="button"
						  style={{
							backgroundColor: '#1877F2',
							color: '#fff',
							textTransform: 'none',
							borderRadius: '4px',
							padding: '10px 20px',
							border: 'none',
							width: 'auto',
							'&:hover': {
								opaciy: '0.8'
							},
							boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
						}} 
						  onClick={launchWhatsAppSignup} className="primary-button mt-3">Login with Facebook</button>
						  ):(
							<></>
						  )}
						  	<pre className='d-none' id="session-info-response"></pre>
							<pre className='d-none' id="sdk-response"></pre>
					</div>
					
					<div className="col-8">
						
								
								{noData ? (
									<center>
										<div className="empty-error-area">
											<img className="empty-error-image w-25 mb-4" src="../../iconss/other/no-results.png"  />
											<h2 className="empty-error-heading">No WhatsApp Account Linked</h2>
											<h6 className="empty-error-subheading" >We couldn't find any whatsapp account associated with your account.</h6>
										</div>
									</center>
								) : (
									<>
										<table>
											<thead>
												<tr>
													<th>WhatsApp Account</th>
													<th>Verification Status</th>
													<th>Date Added</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
											{data.map((item, index) => {
											const formattedDate = new Intl.DateTimeFormat('en-US', {
												year: 'numeric',
												month: 'long',
												day: 'numeric'
											}).format(new Date(item.createdAt));

											return (
												<tr key={item.wabaId} ref={data.length === index + 1 ? lastElementRef : null}>
													<td onClick={() => toggleSidebar(item.phoneNumberId, item.wabaId)} className="td-first cursor-pointer">
													<h6  className="domain-email-name">{item.wabaId}</h6>
													<h6 className="sender-name">{item.phoneNumberId}</h6>
													</td>
													<td><span className={`verfication-status active-status text-capitalize`}>{item.event}</span></td>
													<td className="td-third">{formattedDate}</td>
													<td><a className="download-invoice" onClick={() => handleClickOpen(item.wabaId)}><i className="bi bi-trash"></i></a> <Link className="d-none" to={`/sender-authentication/${item.authenticateId}`}><i className="bi bi-pencil"></i></Link></td>
												</tr>
												);
											})}
											
											</tbody>
										</table>
										{loading && <p>Loading more data...</p>}
									</>
								)}
								
								
								
								
					</div>
					
				</div>
			</div>
			
			<Dialog open={open} onClose={handleCloseDeleteModal}>
					<DialogTitle>Confirm Deletion</DialogTitle>
					<DialogContent>
						<DialogContentText>
							Are you sure you want to delete this WhatsApp Account? This action cannot be undone.
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button onClick={handleCloseDeleteModal} className="text-secondary">
							Cancel
						</Button>
						<Button onClick={handleDelete} className="text-danger">
							Delete
						</Button>
					</DialogActions>
			</Dialog>
			
			{show && (
			<>
			  <div  style={{position: 'fixed',top: 0,left: 0,width: '100%',height: '100%',backgroundColor: 'rgba(0, 0, 0, 0.5)',zIndex: 1040}}  className="modal-overlay" onClick={handleClose}></div>
			  <div className="modal show d-block" tabIndex="-1" role="dialog">
				<div className="modal-dialog" role="document">
				  <div className="modal-content">
					<div className="modal-header w-100">
						<div className="row w-100">
						  <div className="col-11">
							<h5 className="modal-title">Add a new Sender</h5>
						  </div>
						  <div className="col-1">
							  <a style={{textDecoration: 'none'}} className="close" onClick={handleClose}>
								<span style={{fontSize: '2vw', color: 'rgba(100, 100, 100)', cursor: 'pointer'}}>&times;</span>
							  </a>
						  </div>	  
						</div>  
					</div>
					<div className="modal-body pb-4 pt-0 px-4">
					{InputApiArea === 'true' && (
					<div className="row">
						<div className="col-12">
							<label>Sender Name<b className="text-danger">*</b></label>
							<input type="text" ref={NameRef} className={`input-forms w-100 ${NameError ? 'input-error' : ''}`} value={Name} onChange={(e) => {
								  setName(e.target.value);
								}} />
							{ErrorName && <div className="error-message">{ErrorName}</div>}
						</div>
						
						<div className="col-12">
							<label>Sender Email<b className="text-danger">*</b></label>
							<input type="text" ref={EmailRef} className={`input-forms w-100 ${EmailError ? 'input-error' : ''}`} value={Email} onChange={(e) => {
								  setEmail(e.target.value);
								}} />
							{ErrorEmail && <div className="error-message">{ErrorEmail}</div>}
						</div>
					</div>	
					)}
					{InputApiArea === 'false' && (	
						<div className="col-12">
							<div id="step_three" className="right-content">
							  <img src="iconss/other/approved.png" className="success-icon" alt="Success" />
					<h2 className="secondary-heading-modal text-center">{SuccessModalHeading}</h2>
							  <h2 className="secondary-description-modal text-center">{SuccessModalSubHeading}</h2>
							  <center><button type="button" className="primary-button float-center" onClick={handleClose} >Okay</button></center>
							</div>
						</div>
					)}
						
					</div>
					
					{InputApiArea === 'true' && (
					<div className="modal-footer ">
						<button type="button" className="secondary-button" onClick={handleClose} data-bs-dismiss="modal">Cancel</button>
						<button type="button" className="primary-button" onClick={handleAddSender}>Add Sender</button>
					</div>
					)}
					
				  </div>
				</div>
			  </div>
			</>
		  )}
			
			<Snackbar open={snackbarOpen} autoHideDuration={5000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
						<MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>{snackbarMessage}</MuiAlert>
					  </Snackbar>
		  </div>
					
  );
};

export default WhatsAppSenders;
